import { Text as ChakraText, VStack } from '@chakra-ui/layout'
import type { FormikProps } from 'formik'
import React from 'react'
import { colors } from '../../../../ui-kit'
import type {
  SingleSignOnSettingsForm,
  UserSessionResponse,
} from '../../../interfaces'
import CustomPlanCTA from '../../CustomPlan'
import { FeaturesEnum } from '../../../../utils/features'
import SSOSettingsForm from './SSOSettingsForm'

const SSOForm = ({
  form,
  disabled,
}: {
  form: FormikProps<SingleSignOnSettingsForm>
  disabled: boolean
}): React.ReactElement | null => (
  <SSOSettingsForm form={form} disabled={disabled} />
)

const SingleSignOnSettings = ({
  user,
  form,
  disabled,
}: {
  user: UserSessionResponse | null
  form: FormikProps<SingleSignOnSettingsForm>
  disabled: boolean
}): React.ReactElement => {
  const { values, handleChange } = form
  return user?.pricingPlan.featuresList.includes(
    FeaturesEnum.SINGLE_SIGN_ON,
  ) ? (
    <VStack justifyContent="flex-start" alignItems="flex-start" spacing="2em">
      <ChakraText color={colors.appSlate}>
        Save the metadata XML of the SSO Identity Provider you want to integrate
        with ImageKit.
      </ChakraText>
      {SSOForm({ form, disabled })}
    </VStack>
  ) : (
    <CustomPlanCTA feature={FeaturesEnum.SINGLE_SIGN_ON} />
  )
}

export default SingleSignOnSettings
